import {
  EnvironmentProviders,
  Injectable,
  inject,
  provideAppInitializer,
} from '@angular/core';
import { Router } from '@angular/router';

import { Observable, Subscriber } from 'rxjs';

import { Store } from '@ngrx/store';

import { CookieService } from 'ngx-cookie-service';

import dayjs from 'dayjs';

import { AuthenticationStore } from '@xbaht/common/stored/components/authentication.store';

import { GlobalAction, NgRxState } from '@xbaht/common/modules/app-ngrx.module';

import { CookieStorage } from './utils/constants/storage';

import { environment } from '../environments/environment';

var utc = require('dayjs/plugin/utc');
var timezone = require('dayjs/plugin/timezone');
var customParseFormat = require('dayjs/plugin/customParseFormat');
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(customParseFormat);

export function initialize(
  initializeService: InitializeService,
): () => Observable<void> {
  return () => initializeService.initialize();
}

@Injectable({ providedIn: 'root' })
export class InitializeService {
  private _subscriber?: Subscriber<void>;

  constructor(
    private _router: Router,
    private _ngrxStore: Store<NgRxState>,
    private _cookieService: CookieService,
    private _authenticationStore: AuthenticationStore,
  ) {
    this._authenticationStore
      .select((item) => item.verify)
      .subscribe((value) => {
        if (!value?.event?.loading && value?.payload) {
          if (value.payload.verified) {
            this._ngrxStore.dispatch(
              GlobalAction.GlobalAuthAction.SetEmail({
                email: value.payload.email!,
              }),
            );
            this._ngrxStore.dispatch(
              GlobalAction.GlobalAuthAction.SetVerified({
                verified: value.payload.verified,
              }),
            );

            this._ngrxStore.dispatch(
              GlobalAction.GlobalUserAction.SetMe({
                email: value.payload.email!,
                first_name: value.payload.first_name!,
                last_name: value.payload.last_name!,
                roles: value.payload.roles!,
              }),
            );

            this._authenticationStore.token();
          } else {
            this._router.navigate(['', 'auth', 'sign-in'], {
              replaceUrl: true,
            });

            this._subscriber?.complete();
          }
        }
      });

    this._authenticationStore
      .select((item) => item.token)
      .subscribe((value) => {
        if (!value?.event?.loading && value?.payload) {
          if (value.payload.token) {
            this._ngrxStore.dispatch(
              GlobalAction.GlobalAuthAction.SetToken({
                token: value.payload.token,
              }),
            );

            this._cookieService.set(
              CookieStorage.Token,
              value.payload.token || '',
              {
                domain: location.hostname,
                path: '/',
                expires: 1,
                secure: true,
                sameSite: 'None',
              },
            );

            this._authenticationStore.permission();
          } else {
            this._router.navigate(['', 'auth', 'sign-in'], {
              replaceUrl: true,
            });

            this._subscriber?.complete();
          }
        }
      });

    this._authenticationStore
      .select((item) => item.permission)
      .subscribe((value) => {
        if (!value?.event?.loading && value?.payload) {
          this._ngrxStore.dispatch(
            GlobalAction.GlobalPermAction.SetPermission({
              permissions: value.payload,
            }),
          );

          this._subscriber?.complete();
        }
      });
  }

  public initialize(): Observable<void> {
    return new Observable((subscriber) => {
      this._subscriber = subscriber;

      if (!environment.production) {
        console.log(
          `App Start!. (XBaht: v${environment.version} [${
            !environment.production ? environment.mode : ''
          }])`,
        );
      }

      this._ngrxStore.dispatch(GlobalAction.GlobalAppAction.SetStart());

      this._authenticationStore.verify();
    });
  }
}

export const InitializeProvider: EnvironmentProviders = provideAppInitializer(() => {
  const initializerFn = initialize(inject(InitializeService));
  return initializerFn();
});
